import './carousel-timeline.scss';

import enquire from 'enquire.js';
import PubSub from 'pubsub-js';

import { PageEvents } from './page';
import { Responsive } from '../utils';
import tmpl from '../../templates/carousel-timeline.hbs';
import { TextColorCheck } from '../utils/textColorCheck';

const COMPONENT_NAME = 'carousel-timeline';

const BEM = {
  BLOCK: COMPONENT_NAME,
  ELEMENT_GROUP_SLIDER: 'carousel-timeline__group-slider',
  ELEMENT_YEAR: 'carousel-timeline__year',
  ELEMENT_YEAR_TITLE: 'carousel-timeline__year__title',
  ELEMENT_SCROLLER: 'carousel-timeline__scroller',
  ELEMENT_LIST: 'carousel-timeline__list',
  ELEMENT_LIST_ITEM: 'carousel-timeline__list__item',
  MODIFIER_INITIALIZED: 'carousel-timeline--initialized',
  MODIFIER_GROUP_SLIDER_ORIGINAL: 'carousel-timeline__group-slider--original',
  MODIFIER_SYNTHETIC: 'carousel-timeline__synthetic',
};

/**
 * version    1.0
 * class      <type> (CarouselTimeline)
 */
export class CarouselTimeline {
  constructor($container = $('body')) {
    const self = this;

    this._vars = {
      maxHeightMobile: 210,
    };

    this._els = {};
    this._els.container = $container;
    this._els.block = this._els.container.find(`.${BEM.BLOCK}`);

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      this._els.block.each(function () {
        self._initSingleInstance($(this));
        TextColorCheck._checkBackground($(this));
      });
    });
  }

  // private methods

  _checkIfDesktop() {
    const breakpoint = Responsive.getCurrentBreakpointName();
    return breakpoint === 'md' || breakpoint === 'lg';
  }

  _initSingleInstance($instanceEl) {
    const self = this;

    this._extractDomData($instanceEl);

    function updateSlider() {
      self._initSlider($instanceEl);
    }

    enquire.register(`${Responsive.getBreakpointMaxMediaQuery('sm')}`, updateSlider);
    enquire.register(`${Responsive.getBreakpointMinMediaQuery('md')}`, updateSlider);
  }

  _extractDomData($instanceEl) {
    $instanceEl.addClass(BEM.MODIFIER_INITIALIZED);
    const $originalSlider = $instanceEl.find(`.${BEM.MODIFIER_GROUP_SLIDER_ORIGINAL}`);
    const $slides = $originalSlider.find(`.${BEM.ELEMENT_YEAR}`);
    const sliderData = [];
    $slides.each(function () {
      const slideData = {};
      const $slide = $(this);
      const $items = $slide.find(`.${BEM.ELEMENT_LIST_ITEM}`);
      slideData.year = $slide.find(`.${BEM.ELEMENT_YEAR_TITLE}`).html();
      slideData.items = [];
      $items.each(function () {
        slideData.items.push({
          element: $(this),
        });
      });
      sliderData.push(slideData);
    });
    $instanceEl.data('sliderData', sliderData);
  }

  _initSlider($instanceEl) {
    const self = this;
    const mobileLayout = !self._checkIfDesktop();
    const sliderData = $instanceEl.data('sliderData');

    // destroy eventuali slider e scrollbar preesistenti perchè andrò a sostituirli
    $instanceEl.find('.slick-initialized').slick('unslick');

    $instanceEl.find(`.${BEM.ELEMENT_SCROLLER}`).each(function () {
      const scrollbarInstance = $(this).overlayScrollbars();
      if (scrollbarInstance !== undefined) {
        scrollbarInstance.destroy();
      }
    });


    // per ogni annata, scorro gli item e li raggruppo in colonne
    // per soddisfare il constraint del max-height
    for (let i = 0; i < sliderData.length; i += 1) {
      const slide = sliderData[i];
      const columns = [];
      columns.push([]);
      let colCounter = 0;
      let colHeight = 0;
      slide.items.forEach((item) => {
        const itemHeight = item.element.outerHeight(true);

        // Divisione in colonne (solo per mobile):
        // se questo elemento mi porterebbe a sforare l'altezza massima per la colonna corrente
        // allora creo una nuova colonna
        if (mobileLayout && colHeight + itemHeight > self._vars.maxHeightMobile) {
          columns.push([]);
          colCounter += 1;
          colHeight = 0;
        }

        // aggiungo l'elemento alla colonna e ne incremento l'altezza
        colHeight += itemHeight;
        columns[colCounter].push(item.element.html());
      });
      slide.columns = columns;
    }

    // replace the dom element with the newly generated slides
    const newMarkup = tmpl({ sliderData, mobileLayout });
    $instanceEl.find(`.${BEM.MODIFIER_SYNTHETIC}`).remove();
    const $synthetic = $(newMarkup);
    const $titleSlider = $synthetic.find('.carousel-timeline__title-slider');
    const $groupSlider = $synthetic.find('.carousel-timeline__group-slider');
    $instanceEl.append($synthetic);

    // init title slider (anni, solo per mobile)
    $titleSlider.slick({
      infinite: false,
      arrows: false,
      accessibility: false,
      draggable: false,
      swipe: false,
      touchMove: false,
      fade: true,
    });

    // init group slider (elenco puntato, per mobile e desktop)
    $groupSlider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      const $nextSlide = slick.$slides.eq(nextSlide);
      const nextSlideYear = $nextSlide.find('.carousel-timeline__year__title').html();
      const $titleSlide = $titleSlider.find(`[data-year="${nextSlideYear}"]`);
      const titleSlideIndex = $titleSlider.find('.slick-slide').index($titleSlide.closest('.slick-slide'));
      $titleSlider.slick('slickGoTo', titleSlideIndex);
    });

    const arrowSvg = mobileLayout
      ? '<svg role="img" class="svg-icon svg-icon--arrow-left-slider" title="arrow"><use xlink:href="#sprite-arrow-left-slider"></use></svg>'
      : '<svg role="img" class="svg-icon svg-icon--arrow-long-left" title="arrow"><use xlink:href="#sprite-arrow-long-left"></use></svg>';

    const groupSliderOpts = {
      infinite: false,
      prevArrow: `<button type="button" class="slick-prev" aria-label="Previous">${arrowSvg}</button>`,
      nextArrow: `<button type="button" class="slick-next" aria-label="Next">${arrowSvg}</button>`,
    };
    if (!mobileLayout) {
      groupSliderOpts.slidesToShow = 3;
      groupSliderOpts.variableWidth = true;
    }
    $groupSlider.slick(groupSliderOpts);

    // su dekstop inizializzo le scrollbar custom
    if (!mobileLayout) {
      $groupSlider.find(`.${BEM.ELEMENT_SCROLLER}`).each(function () {
        $(this).overlayScrollbars({});
      });
    }
  }
}
